import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AuthenticationService } from "./../services/authentication.service";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
  ViewChildren,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { NavigationService } from "../services/navigation.service";
import { NotificationService } from "../services/notification.service";
import { MatDialog } from "@angular/material/dialog";
import { UserRoleNames, Users } from "../models/users";
import { UserService } from "../services/user.service";
import {
  BehaviorSubject,
  debounceTime,
  interval,
  lastValueFrom,
  skip,
  skipUntil,
  Subject,
  Subscription,
  takeWhile,
  tap,
} from "rxjs";
import { TerminalLoginDialogComponent } from "src/app/core/header/dialogs/terminal-login-dialog/terminal-login-dialog.component";
import { TerminalComponent } from "src/app/core/header/dialogs/terminal/terminal.component";
import { TermsComponent } from "./dialogs/terms/terms.component";
import { PrivacyPolicyComponent } from "./dialogs/privacy-policy/privacy-policy.component";
import { AboutUsComponent } from "./dialogs/about-us/about-us.component";
import { HeaderService } from "../services/header.service";
import { StorageDataTransferService } from "../services/storage-data-transfer.service";
import { DeploymentService } from "../services/deployment.service";
import { StorageService } from "../services/storage.service";
import { ChangePasswordComponent } from "./dialogs/change-password/change-password.component";
import { AuthType, Entities } from "../models/globals";
import { SyncConfigService } from "../services/sync-config.service";
import { ActionLogService } from "src/app/core/services/action-log.service";
import { NgxSpinnerService } from "ngx-spinner";
import { QuickAccessControl } from "../models/quickAccessControl";
import { EnvironmentService } from "../services/environment.service";
import {
  SyncNotification,
  SyncNotificationSubscription,
} from "../models/SyncNotification";
import { Deployment } from "../models/deployment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfigParameter } from "../models/config-entities";
import { ConfigEntityService } from "../services/config-entity.service";
import { ThemeService } from "../services/theme.service";
import { MatMenuTrigger } from "@angular/material/menu";

import {
  NgbOffcanvas,
  OffcanvasDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";

import { HealthService } from "src/app/core/services/health.service";
import { JobsService } from "../services/jobs.service";
import { OAuthService } from "angular-oauth2-oidc";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  isPingLoggedOut: boolean = JSON.parse(localStorage.getItem('authenticationType')) === AuthType.PingIdentity && !localStorage.getItem('currentUser') ? true : false;
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
  diskUsageData: any[];
  serviceStatusData: any[];
  nodeStatusData: any[];
  error: any;
  private timeoutId: any;

  closeResult = "";
  toShowWallet: boolean = false;
  //toShowWallet: boolean = this.env.envVariables.showWalletAmount;
  columnsLocalStorageNames: string[] = [
    "allNodeListColoumnsInfo",
    "nodeListColoumnsInfo",
    "userListColumnsInfo",
  ];
  needToShowValidity: boolean = false;
  needToShowRole: boolean = false;
  showRole: boolean = false;
  toShow;
  currentEntity;
  isHover: boolean = false;
  loggedUserName: string;
  role: string = "";
  notifications = [];
  synchpcTitle: string = this.env.envVariables.synchpcTitle;
  badgeCount = 0;
  daysRemaining: number;
  loggedUserData: Users;
  userWalletAmount: string;
  userSessionAmount: number;
  reloadNotificationData: Subscription;
  reloadUserWallet: Subscription;
  newsFlashSub: Subscription;
  toShowLabel = this.env.envVariables.companyName;
  isGlobalAdmin =
    this.authenticationService.getRole() == UserRoleNames.GlobalAdmin;
  isLicenseExpired: boolean = false;
  universalSub = new BehaviorSubject<boolean>(true);
  deployments: Deployment[] | null;
  selectedDeployment: Deployment;
  refreshNotification = new BehaviorSubject<boolean>(true);
  licenseServerNames: string[];
  @ViewChildren("myDrop") myDrop: any;
  userActivity;
  userInActivityLogOutTime: number | null = null;
  userInactive: Subject<any> = new Subject();
  newsFlash: string[] = [];
  showNewsFlash: boolean = false;
  fullScreen: boolean = false;
  docElement: HTMLElement;
  themeColors = this.themeService.getTheme();
  showInfrastructure: boolean =
    this.env.envVariables.showOvirtInfrastructure || false;
  isActionInProgress: boolean = false;
  options = [];
  selectedOption: string;
  healthData: any;
  dropdownVisible = false; // Flag to track dropdown visibility
  selectedComponent: string | null = null; // Track selected item
  showHealthIcon: boolean = false;
  isDeletingFlag: boolean = false;
  inProgressNotifications: SyncNotification[];
  inProgressNotificationSubscriptions: SyncNotificationSubscription[];
  authType: number = this.authenticationService.getAuthenticationType() || 0;

  constructor(
    private http: HttpClient,
    private healthService: HealthService,
    private actionLogService: ActionLogService,
    private sharedService: NavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    public dialog: MatDialog,
    private userService: UserService,
    private headerService: HeaderService,
    private storageDataTransferService: StorageDataTransferService,
    private storageService: StorageService,
    private depService: DeploymentService,
    private syncConfig: SyncConfigService,
    private spinner: NgxSpinnerService,
    private env: EnvironmentService,
    private snackBar: MatSnackBar,
    private configEntityService: ConfigEntityService,
    private themeService: ThemeService,
    private offcanvasService: NgbOffcanvas,
    private jobsService: JobsService,
    private oauthService: OAuthService
  ) {}

  ngOnInit() {
    this.healthService.getHealthCheckFlag().subscribe({
      next: (data) => {
        if (data == true) {
          this.showHealthIcon = true;
          this.healthService.getHeaderHealth().subscribe({
            next: (data: any) => {
              this.healthData = data.headerHealthEntities;
            },
            error: (err) => {
              console.error(err);
            },
          });
        }
      },
      error: (err) => {
        console.error(err);
      },
    });

    this.getNewFlash();
    this.checkTheme();
    this.docElement = document.documentElement;
    this.authenticationService.currentUser.subscribe(async (user) => {
      if (user == null) {
        this.toShow = false;
        this.userInActivityLogOutTime = null;
        this.reloadNotificationData?.unsubscribe();
        this.reloadUserWallet?.unsubscribe();
      } else {
        this.isPingLoggedOut = JSON.parse(localStorage.getItem('authenticationType')) === AuthType.PingIdentity && !localStorage.getItem('currentUser') ? true : false;
        this.loadNotifications();
        this.toShow = true;
        this.loggedUserName = user.username;
        this.getUserRole();
        this.setUserInActivityCheck();
        this.getUserInActivityLogoutTime();
        this.userInactive.pipe(skip(3)).subscribe(() => {
          if (user) {
            this.logOut();
            this.snackBar.open("Logged out due to user inactivity", "Ok", {
              duration: 5000,
            });
          }
        });
        this.checkUserWallet();
        this.getValidity();

        this.reloadUserWallet = interval(
          this.syncConfig.config.header.notificationReqInterval
        ).subscribe(() => {
          this.checkUserWallet();
          this.loadNotifications();
        });

        this.jobsService.deleteJobObservable$.subscribe((deleted) => {
          if (deleted) {
            this.checkUserWallet();
            this.loadNotifications();
          }
        });

        if (this.role == "Global Admin" || this.role == "Reader") {
          this.showRole = true;
        }
        this.refreshNotification
          .pipe(debounceTime(500))
          .subscribe((s) => this.loadNotifications());
      }
    });
  }

  ngAfterViewInit(): void {
    this.sharedService.breadcrumbEntity.pipe(skip(1)).subscribe((x) => {
      this.currentEntity = x;
    });
  }

  checkTheme() {
    this.themeService.ThemeJson.subscribe((data) => {
      this.themeColors = data;
    });
  }

  async getUserRole() {
    if (
      this.authenticationService.getAuthenticationType() == AuthType.Okta ||
      this.authenticationService.getAuthenticationType() == AuthType.PingIdentity ||
      this.authenticationService.getAuthenticationType() == AuthType.AzureAD
    ) {
      this.userService.getUserRole(this.loggedUserName).subscribe({
        next: async (data) => {
          if (data == 0) {
            this.showRole = true;
            this.role = UserRoleNames.GlobalAdmin;
            this.isGlobalAdmin = true; 
          } else if (data == 1) {
            this.role = UserRoleNames.DeploymentAdmin;
            this.isGlobalAdmin = false; 
          } else {
            this.role = "";
            this.role = this.authenticationService.getRole() || "";
            this.isGlobalAdmin = this.role == UserRoleNames.GlobalAdmin; 
          }
        },
      });
    } else {
      this.role = this.authenticationService.getRole() || "";
      this.isGlobalAdmin = this.role == UserRoleNames.GlobalAdmin; 
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    this.reloadNotificationData?.unsubscribe();
    this.reloadUserWallet?.unsubscribe();
  }

  changeUserPassword() {
    this.dialog.open(ChangePasswordComponent, {
      width: "400px",
      autoFocus: false,
      disableClose: true,
    });
  }

  checkUserWallet() {
    this.userService.getUserDetails(this.loggedUserName).subscribe((data) => {
      this.loggedUserData = <Users>JSON.parse(JSON.stringify(data));
      this.userSessionAmount = this.loggedUserData.sessionWalletBalance;
      if (localStorage.getItem("LicenseExpired")) {
        this.isLicenseExpired = !!localStorage.getItem("LicenseExpired");
      } else {
        if (this.loggedUserData != null) {
          this.userWalletAmount = `${this.loggedUserData.walletAmount} ${this.syncConfig.config.header.walletUiText}`;
          this.toShowWallet = this.loggedUserData.showBilling;
        }
      }
    });
  }

  /*  to show the days remaining  */
  getValidity() {
    this.userService.getUserValidity().subscribe((data) => {
      this.daysRemaining = JSON.parse(JSON.stringify(data));
      if (this.role === "Global Admin") {
        this.needToShowValidity = true;
      } else {
        this.needToShowValidity = false;
      }

      if (this.role === "Global Admin" || this.role === "Reader") {
        this.needToShowRole = true;
      } else {
        this.needToShowRole = false;
      }
    });
  }

  updateNotificationInterval() {
    // Check if there are any in-progress notifications
    if (this.notifications.some((notification) => notification.inProgress)) {
      this.reloadUserWallet?.unsubscribe(); // Unsubscribe the previous interval
      this.reloadUserWallet = interval(
        this.syncConfig.config.header.inprogressReqInterval
      ).subscribe(() => {
        this.checkUserWallet();
        this.loadNotifications();
      });
    } else {
      this.reloadUserWallet?.unsubscribe(); // Unsubscribe the previous interval
      this.reloadUserWallet = interval(
        this.syncConfig.config.header.notificationReqInterval
      ).subscribe(() => {
        this.checkUserWallet();
        this.loadNotifications();
      });
    }
  }

  updateSingleNotificationInterval(id) {
    this.notificationService.getProgressUpdateForNotification(id).subscribe({
      next: (data: any) => {
        if (data) {
          let notification = this.notifications.find((n) => n.id === id);
          if (notification) {
            if (data.inProgress) {
              notification.inProgress = data.inProgress;
              notification.progress = data.progress;
              notification.time = data.time;
              notification.content = data.content;
            }
            if (!data.inProgress) {
              let sub = this.inProgressNotificationSubscriptions.find(
                (d) => d.id == id
              );
              if (sub) {
                sub.subscriptionId.unsubscribe();
                this.inProgressNotificationSubscriptions =
                  this.inProgressNotificationSubscriptions.filter(
                    (d) => d.id != id
                  );
              }
            }
          }
        } else {
          this.spinner.hide("notifications");
        }
      },
      error: (error) => {
        this.spinner.hide("notifications");
      },
    });
  }

  loadNotifications() {
    this.reloadNotificationData = this.notificationService
      .getNotificationsForUser()
      .pipe(tap(() => this.spinner.hide("notifications")))
      .subscribe({
        next: (data) => {
          if (!data) {
            this.notifications = [];
            this.badgeCount = 0;
            return;
          }
          this.notifications = <SyncNotification[]>(
            JSON.parse(JSON.stringify(data))
          );
          this.notifications.sort((a, b) => {
            if (a.inProgress === b.inProgress) {
              return b.time.localeCompare(a.time);
            }
            return a.inProgress ? -1 : 1;
          });
          this.badgeCount = this.notifications.filter(
            (e) => e.viewed == false
          ).length;
          this.isActionInProgress = this.notifications.some((d) => {
            return d.inProgress == true;
          });
          // this.inProgressNotificationSubscriptions = this.notifications.map(
          //   (d) => {
          //     if (d.inProgress && d.content) {
          //       let notificationSubDetail: SyncNotificationSubscription = {
          //         id: d.id,
          //         subscriptionId: null,
          //       };
          //       notificationSubDetail.subscriptionId = interval(
          //         10000
          //       ).subscribe(() => {
          //         this.updateSingleNotificationInterval(d.id);
          //       });
          //       return notificationSubDetail;
          //     }
          //   }
          // );
        },
        error: (error) => {
          this.spinner.hide("notifications");
        },
      });

    this.configEntityService.getSyncHPCConfig().subscribe((data) => {
      let configParameters = <ConfigParameter[]>(
        JSON.parse(JSON.stringify(data))
      );
      this.configEntityService.SyncHpcXMLParameters = configParameters;
    });
    this.updateNotificationInterval();
  }

  userClick() {
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(["/"]);
    } else {
      this.router.navigate(["Login"]);
    }
  }

  logOut() {
    this.clearLocalStorage();
    this.headerService.toRedirectSessions = true;
    this.headerService.toRedirectDeployments = true;
    this.headerService.updateDeploymentList(null);
    this.actionLogService.addActionLog(
      "SyncHPC",
      "SignOut",
      this.loggedUserName,
      this.loggedUserName,
      "User",
      "Sign Out"
    );
    this.authenticationService.logout();

    // Remove local tokens if Ping
    if (this.oauthService.logoutUrl) {
      this.oauthService.logOut(false);
      this.router.navigate(['Logout']);
    } else {
      this.router.navigate(['Login']);
    }
  }

  clearLocalStorage() {
    this.columnsLocalStorageNames.forEach((el) => localStorage.removeItem(el));
  }

  clickedNotification(id: string, event) {
    //if (this.role == UserRoleNames.GlobalAdmin) {
    let currentButton = event.currentTarget;
    currentButton.classList.remove("notificationBtnBefore");
    currentButton.classList.add("notificationBtnAfter");

    let isViewed = this.notifications.filter((e) => e.id == id)[0].viewed;
    if (!isViewed) {
      this.notifications.filter((e) => e.id == id)[0].viewed = true;
      this.badgeCount = this.badgeCount - 1;
    }

    this.notificationService
      .updateNotification(id, false, isViewed)
      .subscribe((data) => {
        if (data) {
        } else {
        }
      });
    //}

    event.stopPropagation();
  }

  helpMenuClicked(id: string) {
    let currentButton = event.currentTarget;
    if (id == "About") {
      const dialogRef = this.dialog.open(AboutUsComponent, {
        width: "40%",
        height: "50%",
        autoFocus: true,
        disableClose: true,
      });
    } else if (id == "Terms") {
      const dialogRef = this.dialog.open(TermsComponent, {
        width: "70vw",
        height: "90vh",
      });
    } else if (id == "Privacy") {
      const dialogRef = this.dialog.open(PrivacyPolicyComponent, {
        width: "70vw",
        height: "90vh",
      });
    } else if (id == "Support") {
      this.gotoExternalDomain(this.env.envVariables.supportLink);
    } else {
      this.gotoExternalDomain(this.env.envVariables.helpLink);
    }
  }

  gotoExternalDomain(url: string) {
    (window as any).open(url, "_blank");
  }

  removeNotification(notificationData, event) {
    this.spinner.show("notifications");
      this.notificationService
        .updateNotification(notificationData.id, true, true)
        .subscribe((data) => {
          if (this.reloadNotificationData)
            this.reloadNotificationData.unsubscribe();
          this.loadNotifications();
        });
    event.stopPropagation();
  }

  clearAllNotifications(event) {
    this.spinner.show("notifications");
    this.notifications = [];
    this.notificationService.clearAllNotification(true).subscribe((data) => {
      this.loadNotifications();
      this.badgeCount = 0;
    });
    event.stopPropagation();
  }

  userMenuClicked(event) {
    event.stopPropagation();
  }

  openConfigurator() {
    let currenturl = this.router.url;
    if (!decodeURI(currenturl).includes("Configurator")) {
      this.router.navigate(["/Conf"]);
    }
  }

  openTerminal() {
    let hostIp = this.extractHostIP(this.env.envVariables.webHost);
    const loginDialog = this.dialog.open(TerminalLoginDialogComponent, {
      width: "25vw",
      autoFocus: false,
      disableClose: true,
      data: {
        depName: null,
        headNodeIp: hostIp,
      },
    });
    loginDialog.afterClosed().subscribe((data) => {
      if (data) {
        this.sharedService.closeOpenedDialogs();
        this.dialog.open(TerminalComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: "custom-terminal-container",
          hasBackdrop: false,
          id: "terminalDialog",
          data: {
            username: data.username,
            password: data.password,
            serverAddress: `${this.env.envVariables.httpProtocol}${hostIp}:${this.env.envVariables.UtilityAccessPort}/`,
          },
        });
      }
    });
  }

  extractHostIP(url: string): string {
    let host = '';
    host = url.replace(/^https?:\/\//, '');
    host = host.split('/')[0];
    host = host.split(':')[0];
    return host;
  }

  mouseEnter(idx) {
    this.myDrop._results[idx].open();
  }

  mouseLeave(idx) {
    this.myDrop._results[idx].close();
  }

  manualNotificationsRefresh(event) {
    event.stopPropagation();
    this.spinner.show("notifications");
    this.refreshNotification.next(true);
  }

  getUserInActivityLogoutTime() {
    this.authenticationService.getUserInactivityLogoutTime().subscribe({
      next: (data) => {
        this.userInActivityLogOutTime = data.actionMessage;
      },
    });
  }

  setUserInActivityCheck() {
    this.userActivity = setTimeout(
      () => this.userInactive.next(undefined),
      this.userInActivityLogOutTime * 60000
    );
  }
  @HostListener("window:mousemove")
  @HostListener("document:keypress")
  @HostListener("document:click")
  @HostListener("document:wheel")
  refreshUserState() {
    if (!this.userInActivityLogOutTime) return;
    clearTimeout(this.userActivity);
    this.setUserInActivityCheck();
  }

  getNewFlash() {
    this.headerService.getNewFlash().subscribe({
      next: (data: any) => {
        if (data?.flashNews) {
          this.showNewsFlash = true;
          this.newsFlash = data?.flashNews?.split(",");
        } else {
          this.showNewsFlash = false;
        }
      },
      error: (err) => {
        this.showNewsFlash = false;
      },
    });
  }

  copyToClipboard(): void {
    const token = JSON.parse(localStorage.currentUser).token;

    const dummyElement = document.createElement("input");
    document.body.appendChild(dummyElement);
    dummyElement.value = token;
    dummyElement.select();
    document.execCommand("copy");
    document.body.removeChild(dummyElement);
    this.snackBar.open(
      "Token copied to clipboard! Use Ctrl + V to paste",
      "Ok",
      {
        duration: 4000,
      }
    );
  }

  toShowTerminal() {
    if (!this.toShow) return false;
    if (this.role != UserRoleNames.GlobalAdmin) return false;
    if (!this.env.envVariables.showTerminalInHeader) return false;
    return true;
  }

  toShowHealth() {
    if (!this.toShow) return false;
    if (this.role != UserRoleNames.GlobalAdmin) return false;
    return true;
  }

  toggleFullScreen() {
    if (!this.fullScreen) {
      this.docElement.requestFullscreen();
    } else {
      if (document.fullscreenElement) {
        document?.exitFullscreen();
      } else {
        this.docElement.requestFullscreen();
        this.fullScreen = false;
      }
    }
    this.fullScreen = !this.fullScreen;
  }

  openSyncHpcInfra() {
    window.open("https://ovirt-engine.lab.local/ovirt-engine/", "_blank");
  }

  open(content: TemplateRef<any>) {
    this.offcanvasService
      .open(content, {
        position: "end",
        ariaLabelledBy: "offcanvas-basic-title",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === OffcanvasDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === OffcanvasDismissReasons.BACKDROP_CLICK) {
      return "by clicking on the backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  formatData(data: any): any[] {
    return Object.keys(data).map((key) => ({ key, value: data[key] }));
  }

  //function to makle keys dynamic
  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  getHealthData(): void {
    this.http.get("HealthHeader.json").subscribe((data: any) => {
      this.healthData = Object.values(data);
    });
  }

  fetchHealthData(): void {
    this.healthService.getHealthStatus().subscribe(
      (data) => {
        this.healthData = data; // Log received data to console
      },
      (error) => {
        this.error = error; // Assign error for error handling in template
      }
    );
  }

  toggleDropdown(): void {
    this.dropdownVisible = !this.dropdownVisible;
  }

  onHeartButtonClick(section: string) {
    //this.healthService.activeTab = section

    this.healthService.updateActiveHealthTab(section);
    this.configEntityService.sendActiveEntity("Health");
    this.router.navigate([`Configurator/Health`]);
  }

  navigateToHealth(): void {
    this.configEntityService.sendActiveEntity("Health");
    this.router.navigate([`Configurator/Health`]);
  }

  getBadgeInfo(): { icon: string; color: string } {
    if (this.healthData?.some((item) => item.Health === "Error")) {
      return { icon: "bi bi-x-circle-fill", color: "red" }; // Icon and color for ERROR
    } else if (this.healthData?.some((item) => item.Health === "Warning")) {
      return { icon: "bi bi-exclamation-circle-fill", color: "orange" }; // Icon and color for Warning
    } else if (this.healthData?.some((item) => item.Health === "Ok")) {
      return { icon: "bi bi-check-circle-fill", color: "#5eff00" }; // Icon and color for Ok
    } else {
      return { icon: "", color: "" }; // No badge
    }
  }

  onMouseEnter() {
    // Clear any existing timeout to avoid premature closing
    clearTimeout(this.timeoutId);
    this.menuTrigger.openMenu();
  }

  onMouseLeave() {
    // Set a timeout to close the menu if the mouse is not hovering over the menu
    this.timeoutId = setTimeout(() => {
      this.menuTrigger.closeMenu();
    }, 200); // Adjust the timeout as needed
  }

  isSelected(item: string): boolean {
    return this.selectedComponent === item;
  }
}
